import script from "./FinalForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinalForm.vue?vue&type=script&setup=true&lang=ts"

import "./FinalForm.vue?vue&type=style&index=0&id=873d4f6a&scoped=true&lang=scss"

import exportComponent from "/app/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-873d4f6a"]])

export default __exports__